import format from 'date-fns/format'
import type {
  GridValueGetterParams,
  GridValueFormatterParams,
} from '@mui/x-data-grid-pro'

export function getCreatedDate(params: GridValueGetterParams) {
  const { value } = params
  return value ? new Date(value) : null
}

export function formatCreatedDate(params: GridValueFormatterParams) {
  const { value } = params
  return value ? format(value as Date, 'MM/dd/yy') : null
}
